@use '../@shared/mixins' as *;
@use '../../styles/global' as *;
@use '../host-display-block' as *;

@layer kol-component {
	.kol-avatar,
	.kol-avatar__image,
	.kol-avatar__initials {
		border-radius: 50%;
	}

	.kol-avatar {
		/* Visible with forced colors  */
		outline: transparent solid to-rem(1);

		display: flex;
		width: to-rem(100);
		height: to-rem(100);

		&__initials {
			background-color: inherit;
			margin: auto;

			font-size: to-rem(40);
		}
	}
}
